// GET PERFORMANCE STATICS
export const GET_PERFORMANCE_STATICS = 'GET_PERFORMANCE_STATICS';
export const GET_PERFORMANCE_STATICS_SUCCESS = 'GET_PERFORMANCE_STATICS_SUCCESS';
export const GET_PERFORMANCE_STATICS_FAILURE = 'GET_PERFORMANCE_STATICS_FAILURE';

// GET PERFORMANCE OVERVIEWS
export const GET_PERFORMANCE_OVERVIEWS = 'GET_PERFORMANCE_OVERVIEWS';
export const GET_PERFORMANCE_OVERVIEWS_SUCCESS = 'GET_PERFORMANCE_OVERVIEWS_SUCCESS';
export const GET_PERFORMANCE_OVERVIEWS_FAILED = 'GET_PERFORMANCE_OVERVIEWS_FAILED';

// GET PERFORMANCE CHARTS
export const GET_PERFORMANCE_CHARTS = 'GET_PERFORMANCE_CHARTS';
export const GET_PERFORMANCE_CHARTS_SUCCESS = 'GET_PERFORMANCE_CHARTS_SUCCESS';
export const GET_PERFORMANCE_CHARTS_FAILED = 'GET_PERFORMANCE_CHARTS_FAILED';

// GET INSIGHT OVERVIEW
export const GET_INSIGHT_OVERVIEW = 'GET_INSIGHT_OVERVIEW';
export const GET_INSIGHT_OVERVIEW_SUCCESS = 'GET_INSIGHT_OVERVIEW_SUCCESS';
export const GET_INSIGHT_OVERVIEW_FAILED = 'GET_INSIGHT_OVERVIEW_FAILED';

// GET REVENUA DISTRIBUTION OVERVIEW
export const GET_REVENUE_DISTRIBUTION_OVERVIEW = 'GET_REVENUE_DISTRIBUTION_OVERVIEW';
export const GET_REVENUE_DISTRIBUTION_OVERVIEW_SUCCESS = 'GET_REVENUE_DISTRIBUTION_OVERVIEW_SUCCESS';
export const GET_REVENUE_DISTRIBUTION_OVERVIEW_FAILED = 'GET_REVENUE_DISTRIBUTION_OVERVIEW_FAILED';

// GET REVENUA DISTRIBUTION CHART
export const GET_REVENUE_DISTRIBUTION_CHART = 'GET_REVENUE_DISTRIBUTION_CHART';
export const GET_REVENUE_DISTRIBUTION_CHART_SUCCESS = 'GET_REVENUE_DISTRIBUTION_CHART_SUCCESS';
export const GET_REVENUE_DISTRIBUTION_CHART_FAILED = 'GET_REVENUE_DISTRIBUTION_CHART_FAILED';
